// @ts-strict-ignore
import React, { FC } from 'react'
import { IonRow, IonHeader, IonToolbar, IonButtons, IonCol, IonGrid } from '@ionic/react'
import Button from '../../../common/components/Button'
import strings from '../../../../strings'
import '@google/model-viewer'

interface FullscreenArProps {
	usdz?: string
	glb?: string
	onClose?: () => void
	filename?: string
}

const FullscreenAr: FC<FullscreenArProps> = ({ usdz, glb, onClose, filename }) => (
	<IonGrid className="fullscreen-video-container">
		<IonRow className="fullscreen-video-row">
			<IonCol>
				<IonRow className="header-row">
					<IonHeader className="header fullscreen-video-header">
						<IonToolbar className="header-toolbar">
							<IonButtons slot="end" className="header-buttons">
								<Button
									className="back-button"
									onClick={onClose}
									player-action-attribute="player-action-attribute"
									ariaLabel={strings.accessibility_go_back}
								>
									<i className="fal fa-xmark close-icon" />
								</Button>
							</IonButtons>
						</IonToolbar>
					</IonHeader>
				</IonRow>
				<IonRow className="player-row" style={{ zIndex: 100 }}>
					{/* @ts-ignore */}
					<model-viewer src={glb} ios-src={usdz} alt={filename} ar={true} auto-rotate={true} camera-controls={true} />
				</IonRow>
			</IonCol>
		</IonRow>
	</IonGrid>
)

export default FullscreenAr
